import { create } from 'zustand';

interface WebphoneState {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
}

export const useWebphoneStore = create<WebphoneState>((set) => ({
  isOpen: false,
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  close: () => set({ isOpen: false }),
}));
